import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Save, Send, Eye } from 'lucide-react';
import { CodeEditor } from '../components/CodeEditor';
import { PreviewModal } from '../components/PreviewModal';
import { EmailPreview } from '../components/EmailPreview';
export function EmailTemplateEditor() {
  const [showPreview, setShowPreview] = useState(false);
  const [templateData, setTemplateData] = useState({
    subject: 'Please confirm your subscription',
    html: `<!DOCTYPE html>
<html>
<body>
  <h1>Welcome!</h1>
  <p>Please click the link below to confirm:</p>
  <a href="{{confirmation_link}}">Confirm Subscription</a>
</body>
</html>`
  });
  return <div className="space-y-6" data-id="element-1023">
      <div className="flex items-center justify-between" data-id="element-1024">
        <div className="flex items-center gap-4" data-id="element-1025">
          <Link to="/templates" className="p-2 hover:bg-gray-100 rounded-full text-gray-500" data-id="element-1026">
            <ArrowLeft className="h-5 w-5" data-id="element-1027" />
          </Link>
          <div data-id="element-1028">
            <h1 className="text-2xl font-semibold text-gray-900" data-id="element-1029">
              Edit Template
            </h1>
            <p className="text-sm text-gray-500" data-id="element-1030">
              Design your email with custom HTML.
            </p>
          </div>
        </div>
        <div className="flex items-center gap-3" data-id="element-1031">
          <button onClick={() => setShowPreview(true)} className="inline-flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 text-gray-700 text-sm font-medium rounded-md hover:bg-gray-50" data-id="element-1032">
            <Eye className="h-4 w-4" data-id="element-1033" />
            Preview
          </button>
          <button className="inline-flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 text-gray-700 text-sm font-medium rounded-md hover:bg-gray-50" data-id="element-1034">
            <Send className="h-4 w-4" data-id="element-1035" />
            Send Test
          </button>
          <button className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700" data-id="element-1036">
            <Save className="h-4 w-4" data-id="element-1037" />
            Save Changes
          </button>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-6" data-id="element-1038">
        <div className="col-span-2 space-y-6" data-id="element-1039">
          <div className="bg-white border border-gray-200 rounded-lg p-6 space-y-4" data-id="element-1040">
            <div className="space-y-2" data-id="element-1041">
              <label className="block text-sm font-medium text-gray-700" data-id="element-1042">
                Email Subject
              </label>
              <input type="text" className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" value={templateData.subject} onChange={e => setTemplateData({
              ...templateData,
              subject: e.target.value
            })} data-id="element-1043" />
            </div>

            <div className="space-y-2" data-id="element-1044">
              <label className="block text-sm font-medium text-gray-700" data-id="element-1045">
                Preheader Text (Optional)
              </label>
              <input type="text" className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" placeholder="Brief summary displayed in inbox..." data-id="element-1046" />
            </div>

            <CodeEditor label="Email HTML Body" language="html" className="min-h-[400px]" value={templateData.html} onChange={e => setTemplateData({
            ...templateData,
            html: e.target.value
          })} data-id="element-1047" />
          </div>
        </div>

        <div className="space-y-6" data-id="element-1048">
          <div className="bg-white border border-gray-200 rounded-lg p-4" data-id="element-1049">
            <h3 className="text-sm font-medium text-gray-900 mb-3" data-id="element-1050">
              Available Variables
            </h3>
            <div className="space-y-2" data-id="element-1051">
              <div className="flex items-center justify-between text-sm" data-id="element-1052">
                <code className="bg-gray-100 px-1.5 py-0.5 rounded text-blue-600" data-id="element-1053">
                  {'{{confirmation_link}}'}
                </code>
                <span className="text-gray-500" data-id="element-1054">Required</span>
              </div>
              <div className="flex items-center justify-between text-sm" data-id="element-1055">
                <code className="bg-gray-100 px-1.5 py-0.5 rounded text-gray-600" data-id="element-1056">
                  {'{{first_name}}'}
                </code>
                <span className="text-gray-500" data-id="element-1057">Optional</span>
              </div>
              <div className="flex items-center justify-between text-sm" data-id="element-1058">
                <code className="bg-gray-100 px-1.5 py-0.5 rounded text-gray-600" data-id="element-1059">
                  {'{{team_name}}'}
                </code>
                <span className="text-gray-500" data-id="element-1060">System</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <PreviewModal isOpen={showPreview} onClose={() => setShowPreview(false)} title="Email Template Preview" data-id="element-1061">
        <EmailPreview subject={templateData.subject} html={templateData.html} data-id="element-1062" />
      </PreviewModal>
    </div>;
}